<template>
	<q-page padding>
		<div class="q-display-1 q-mb-md text-secondary">
			<q-icon name="fas fa-hashtag" class="q-mb-sm" /> {{ $t('tags') }}
		</div>

		<div class="row gutter-sm">
			<div class="col-sm-1 flex justify-center items-center">
				<q-btn :label="$t('icon')" color="tertiary" @click="show_icons = true" />
			</div>
			<div class="col-sm-11 col-xs-12">
				<q-field :count="30">
					<q-input
						v-model="title"
						:float-label="$t('title')"
						:error="$v.title.$error"
						@input="$v.title.$touch"
						maxlength="30"
					/>
				</q-field>
			</div>

			<div class="col-xs-12 col-sm-12">
				<select-multiple
					label="knowledge_areas"
					:filters="areas"
					:options="area_countries"
					@on_value="areas = $event"
					:error="$v.areas.$error"
					:input="$v.areas.$touch"
				/>
			</div>
			<div class="q-mt-md	row col-xs-12 col-sm-6 justify-around">
				<div class="col-xs-12 col-sm-5 ">
					<p class="caption">{{ $t('background_color') }}</p>
					<q-color-picker v-model="background_color" />
				</div>
				<div
					class="col-xs-12 col-sm-5"
					:class="$q.platform.is.desktop ? 'q-mt-none' : 'q-mt-md'"
				>
					<p class="caption">{{ $t('text_color') }}</p>
					<q-color-picker v-model="text_color" />
				</div>
			</div>

			<div class=" column col-xs-12 col-sm-6 q-mt-md flex justify-center items-center">
				<p class="caption text-bold">{{ $t('preview') }}</p>
				<q-card
					class="flex justify-center items-center card-size round-borders"
					:style="`background-color:${background_color}`"
				>
					<q-card-main class="text-center title q-title text-white">
						<q-icon :name="icon" class="q-mb-sm" :style="`color:${text_color}`" />
						<p
							class="q-mb-none text-center text-weight-bold"
							:style="`color:${text_color}`"
						>
							{{ title }}
						</p>
					</q-card-main>
				</q-card>
			</div>

			<div class="row reverse col-12">
				<div :class="$q.platform.is.desktop ? ' ' : 'col-6'">
					<p class="caption">{{ $t('status') }}</p>
					<q-btn-toggle
						v-model="status"
						:toggle-color="getColorStatus"
						:options="statuses"
					/>
				</div>
				<div :class="$q.platform.is.desktop ? 'q-mr-md' : 'q-mr-none col-6'">
					<p class="caption">{{ $t('highlight') }}</p>
					<q-btn-toggle
						v-model="is_featured"
						:toggle-color="getColorFeatured"
						:options="featureds"
					/>
				</div>
			</div>
		</div>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="fas fa-chevron-left"
					@click="$router.push({ name: 'admin_tags' })"
				/>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
				<q-btn
					color="secondary"
					class="full-width"
					:label="$t('save')"
					icon="far fa-save"
					@click="saveData()"
				/>
			</div>
		</div>

		<q-modal v-model="show_icons" :content-css="{ maxWidth: getMaxWidth, minHeight: '80vh' }">
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_icons = false" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('icon') }}
					</q-toolbar-title>
				</q-toolbar>

				<q-toolbar slot="header">
					<q-search
						class="full-width"
						inverted
						v-model="search"
						color="none"
						:debounce="500"
					/>
				</q-toolbar>

				<div class="layout-padding">
					<div
						class="category-icon-item"
						v-for="(icon, index) in iconList"
						:key="index"
						@click="selectIcon(icon)"
					>
						<q-icon :name="'fas fa-' + icon" />
					</div>
				</div>
			</q-modal-layout>
		</q-modal>
	</q-page>
</template>

<script>
import icons from 'assets/icons.json'
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import SelectMultiple from 'components/utils/SelectMultiple'
export default {
	i18nOptions: { namespaces: ['custom', 'common', 'training', 'admin'] },
	name: 'Tag',
	data() {
		return {
			areas: [],
			is_featured: false,
			featureds: [
				{
					label: this.$t('yes'),
					value: true,
				},
				{
					label: this.$t('no'),
					value: false,
				},
			],
			id_tag: '',
			status: 1,
			statuses: [
				{
					label: this.$t('active_f'),
					value: 1,
				},
				{
					label: this.$t('inactive_f'),
					value: 2,
				},
			],
			title: '',
			background_color: '#cccccc',
			text_color: '#ffffff',
			show_icons: false,
			icon: 'fas fa-certificate',
			icons: [],
			search: '',
			class_hover: `bg-${this.index % 4}`,
		}
	},

	components: {
		'select-multiple': SelectMultiple,
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			area_countries: 'registration_lists/country_areas',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getColorStatus() {
			if (this.status == 1) return 'positive'
			else return 'negative'
		},

		getColorFeatured() {
			if (this.is_featured) return 'positive'
			else return 'negative'
		},

		iconList() {
			if (this.search) {
				return this.icons.filter((e) => {
					return e.includes(this.search)
				})
			} else return this.icons
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},
	},

	methods: {
		fetchData() {
			this.$axios
				.get('/admin_tags/tags/' + this.id_tag + '/', this.getHeader)
				.then((response) => {
					this.title = response.data.title
					this.status = response.data.status
					this.is_featured = response.data.is_featured
					this.background_color = response.data.background_color
					this.text_color = response.data.text_color
					this.icon = response.data.icon

					response.data.areas.forEach((area, index) => {
						this.areas.push(area)
					})

					this.$q.loading.hide()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		saveData() {
			this.$v.$touch()

			if (!this.$v.$error) {
				this.$q.loading.show()

				let fd = new FormData()
				fd.append('title', this.title)
				fd.append('is_featured', this.is_featured)
				fd.append('background_color', this.background_color)
				fd.append('text_color', this.text_color)
				fd.append('icon', this.icon)

				let areas = []
				this.areas.forEach((area, index) => {
					fd.append('areas', area)
				})

				fd.append('status', this.status)

				if (this.id_tag != 0) {
					this.$axios
						.put('/admin_tags/tags/' + this.id_tag + '/', fd, this.getHeader)
						.then((response) => {
							this.$q.loading.hide()
							this.$router.push({ name: 'admin_tags' })
						})
						.catch((e) => {
							this.$q.loading.hide()
							console.log(e)
						})
				} else {
					this.$axios
						.post('/admin_tags/tags/', fd, this.getHeader)
						.then((response) => {
							this.$q.loading.hide()
							this.$router.push({ name: 'admin_tags' })
						})
						.catch((e) => {
							this.$q.loading.hide()
							console.log(e)
						})
				}
			} else {
				this.$q.notify({
					message: this.$t('make_sure_that_all_fields_are_filled_in'),
					type: 'negative',
					icon: 'fas fa-exclamation-triangle',
					position: 'top',
				})
			}
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		selectIcon(icon) {
			this.icon = 'fas fa-' + icon
			this.search = ''
			this.show_icons = false
		},
	},

	created() {
		icons[0].solid.forEach((icon) => {
			this.icons.push(icon)
		})

		this.id_tag = this.$route.params.id
		if (this.id_tag != 0) this.fetchData()
	},

	validations() {
		return {
			title: { required },
			areas: { required },
		}
	},
}
</script>

<style lang="stylus" scoped>
.category-icon-item
    float left
    border 1px solid #EFEFEF
    display table
    width 3rem
    height 3rem
    &:hover
        border 1px solid #000000
.category-icon-item i
    margin 0 auto
    margin-top 0.5rem
    font-size 2rem
    text-align center
    vertical-align middle
    display table-cell
    cursor pointer
    color #444
		.card-size
			width 200px
			min-height 120px

		.card-size p
			max-width 185px
			word-break break-all
</style>
